//
// Menus
//
export var ODMenuItemType;
(function (ODMenuItemType) {
    ODMenuItemType["Text"] = "Text";
    ODMenuItemType["Dropdown"] = "Dropdown";
})(ODMenuItemType || (ODMenuItemType = {}));
//# sourceMappingURL=globalInterfaces.js.map